module.exports = __webpack_public_path__ + "static/media/IRON-ETH.501c5060.png";